import {reqWithToken} from './requestHelper';

export async function getSys() {
    return (await reqWithToken('api/gxbooking/setting/sys')).data;
}

export async function updateSys(sys) {
    return (await reqWithToken('api/gxbooking/setting/sys', {
        data: sys,
        method: 'put'
    })).data;
}

export async function getMails() {
    return (await reqWithToken('api/gxbooking/setting/mails')).data;
}

export async function updateMail(mail) {
    return (await reqWithToken('api/gxbooking/setting/mails', {
        data: mail,
        method: 'put'
    })).data;
}

export async function getIndustry() {
    return (await reqWithToken('api/gxbooking/setting/industry')).data;
}

export async function updateIndustry(sys) {
    return (await reqWithToken('api/gxbooking/setting/industry', {
        data: sys,
        method: 'put'
    })).data;
}

export async function getWeekRanges(params) {
    return (await reqWithToken('api/schoolInfo/weeks',{
        params:params
    })).data;
}

export async function getSpecialMappings() {
    return (await reqWithToken('api/gxbooking/SpecialPeriodMapping')).data;
}

export async function getPeriodsDefs() {
    return {
        dayPeriods: [
            {
                period: 1,
                text: '08:10-09:00'
            },
            {
                period: 2,
                text: '09:10-10:00'
            },
            {
                period: 3,
                text: '10:10-11:00'
            },
            {
                period: 4,
                text: '11:10-12:00'
            },
            {
                period: 5,
                text: '13:10-14:00'
            },
            {
                period: 6,
                text: '14:10-15:00'
            },
            {
                period: 7,
                text: '15:10-16:00'
            },
            {
                period: 8,
                text: '16:10-17:00'
            },
            {
                period: 9,
                text: '17:10-18:00'
            },
            {
                period: 10,
                text: '18:10-18:55'
            },
            {
                period: 11,
                text: '19:00-19:45'
            },
            {
                period: 12,
                text: '19:50-20:35'
            },
            {
                period: 13,
                text: '20:40-21:25'
            },
            {
                period: 14,
                text: '21:30-22:15'
            },
            {
                period: 15,
                text: '07:10-08:00晨課'
            },
            {
                period: 16,
                text: '12:10-13:00午課'
            },
            {
                period: 17,
                text: '07:10-08:00'
            }
        ],
        collegePeriods: [
            {
                period: 1,
                text: '08:30-09:15'
            },
            {
                period: 2,
                text: '09:20-10:05'
            },
            {
                period: 3,
                text: '10:10-10:55'
            },
            {
                period: 4,
                text: '11:00-11:45'
            },
            {
                period: 5,
                text: '11:50-12:35'
            },
            {
                period: 6,
                text: '12:40-13:25'
            },
            {
                period: 7,
                text: '13:30-14:15'
            },
            {
                period: 8,
                text: '14:20-15:05'
            },
            {
                period: 9,
                text: '15:10-15:55'
            },
            {
                period: 10,
                text: '16:00-16:45'
            },
            {
                period: 11,
                text: '16:50-17:35'
            },
            {
                period: 12,
                text: '17:40-18:25'
            },
            {
                period: 13,
                text: '18:30-19:15'
            },
            {
                period: 14,
                text: '19:20-20:05'
            },
            {
                period: 15,
                text: '20:10-20:55'
            },
            {
                period: 16,
                text: '21:00-21:45'
            },
            {
                period: 17,
                text: '07:10-08:00'
            }
        ]
    };
}

export async function insertRoom(room){
    return (await reqWithToken('api/gxbooking/classrooms',{
        data: room,
        method: 'post'
    })).data;
}

export async function updateRoom(room){
    return (await reqWithToken('api/gxbooking/classrooms',{
        data: room,
        method: 'put'
    })).data;
}

export async function deleteRoom(id){
    return (await reqWithToken('api/gxbooking/classrooms',{
        params: {id},
        method: 'delete'
    })).data;
}

export async function downloadTemplate(){
    return (await reqWithToken('api/gxbooking/SpecialPeriodMapping/template', {
        responseType: 'blob'
    })).data;
}

export async function downloadCurrent(){
    return (await reqWithToken('api/gxbooking/SpecialPeriodMapping/current', {
        responseType: 'blob'
    })).data;
}